
import { defineComponent } from "vue";
import PreguntasFrecuentes from "@/components/TransmisionNomina/PreguntasFrecuentes.vue";

export default defineComponent({
  components: { PreguntasFrecuentes }
});
